import { render, staticRenderFns } from "./publication_data_table.vue?vue&type=template&id=a4be9fb0"
import script from "./publication_data_table.vue?vue&type=script&lang=js"
export * from "./publication_data_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports